let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fhPcC")).then(() => parcelRequire('iw22C'));